export default __webpack_public_path__ + "static/logo-522f80351bc414b12eca011b8dcc06b8.svg";